export const environment = {
  production: true,
  apiUrl: 'https://videowand-leipzig.de'
};
